<template>
  <footer class="footer-container">
    <div class="footer-content">
      <img src="@/assets/logo4.png" alt="Logo" class="footer-logo" />
      <div class="footer-text">
        <div class="footer-title">MY EVENTO DIGITAL</div>
        <div class="footer-subtext">Invitaciones Digitales</div>
        <div class="footer-subtext">Gestión de lista de invitados</div>
      </div>
    </div>

    <!-- Íconos de redes sociales -->
    

    <!-- Texto inferior con enlaces -->
    <div class="footer-bottom">
      <p class="footer-link">
        ¿Te interesa nuestro servicio? <br />
<a href="https://wa.me/16128072269?text=Hola,%20me%20puedes%20dar%20informaci%C3%B3n%20de%20invitaciones%20digitales,%20vengo%20de%20parte%20de%20Gracie%20Audelia" class="demo-link">
  Pide un demo
</a>      </p>
      <p class="copyright">
        © 2024 por My Evento Digital
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>

/* Fondo oscuro y elegante */
.footer-container {
 background-image: linear-gradient(rgba(175, 206, 243, 0.89), rgba(158, 188, 230, 0.934)),
  url('../assets/fondoflores.jpg'); color: #ffff;
  padding: 60px 20px 30px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  clip-path: ellipse(90% 100% at center top);
}

/* Logo */
.footer-logo {
  width: 60px;
  height: auto;
  margin-bottom: 15px;
}

/* Contenido principal */
.footer-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.footer-title {
  font-size: 14px;
  color: #fff;
  margin-bottom: 5px;
}

.footer-subtext {
  font-family: 'padres';
  font-size: 14px;
  color: #ffff;
  line-height: 1.5;
}

/* Redes sociales */
.footer-icons {
  display: flex;
  gap: 15px;
  margin-top: 20px;
}

.footer-icon {
  width: 30px;
  height: auto;
  transition: transform 0.3s ease;
  filter: brightness(0) invert(1);
}

.footer-icon:hover {
  transform: scale(1.1);
}

.whatsapp-icon {
  width: 28px;
}

/* Parte inferior */
.footer-bottom {
  margin-top: 20px;
  font-size: 13px;
  color: #aaa;
  font-family: 'padres';
}

.footer-link {
  font-size: 13px;
  color: #ccc;
  font-family: 'padres';
}

.demo-link {
  color: #ffffff;
  font-weight: 600;
  background-color: #000;
  padding: 8px 18px;
  border-radius: 6px;
  text-decoration: none;
  margin-top: 8px;
  display: inline-block;
  transition: background 0.3s ease;
  font-family: 'padres';
}

.demo-link:hover {
  background-color: #333;
}

.copyright {
  margin-top: 10px;
  font-size: 12px;
  opacity: 0.5;
}

/* Responsive */
@media (max-width: 576px) {
  .footer-container {
    padding: 50px 15px;
  }
}
</style>
